import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Droplets } from "lucide-react";

export default function PortalWater() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/portal/irrigation").then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="p-6 font-bold uppercase text-sm">Loading water records…</div>;

  return (
    <div className="space-y-4" data-testid="portal-water">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {data.blocks.map((b) => (
          <div key={b.block_id} data-testid={`portal-water-block-${b.block_id}`} className="bg-white border border-stone-200 p-4 space-y-2">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-bold text-lg" style={{ fontFamily: "'Fraunces', serif" }}>{b.block_label}</div>
                <div className="text-xs text-stone-500">{b.ranch_number} · {b.vineyard_name}</div>
              </div>
              <Droplets size={18} className="text-sky-500" />
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              <div className="bg-sky-50 border border-sky-100 p-2">
                <div className="text-lg font-bold" style={{ fontFamily: "'Fraunces', serif" }}>{b.season_gallons.toLocaleString()}</div>
                <div className="text-[9px] font-bold uppercase text-stone-500">Gal {data.year}</div>
              </div>
              <div className="bg-sky-50 border border-sky-100 p-2">
                <div className="text-lg font-bold" style={{ fontFamily: "'Fraunces', serif" }}>{b.season_gal_per_vine ?? "—"}</div>
                <div className="text-[9px] font-bold uppercase text-stone-500">Gal / Vine</div>
              </div>
              <div className="bg-sky-50 border border-sky-100 p-2">
                <div className="text-lg font-bold" style={{ fontFamily: "'Fraunces', serif" }}>{b.season_hours}</div>
                <div className="text-[9px] font-bold uppercase text-stone-500">Hours</div>
              </div>
            </div>
            <div className="text-[11px] text-stone-500">Last irrigated: <b>{b.last_date || "—"}</b></div>
          </div>
        ))}
        {data.blocks.length === 0 && (
          <div className="col-span-full bg-white border border-stone-200 p-10 text-center text-stone-400 font-bold uppercase text-sm" data-testid="portal-water-empty">No blocks assigned</div>
        )}
      </div>

      <div className="bg-white border border-stone-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#1F3D34] text-white text-left text-[10px] uppercase">
              <th className="p-3">Date</th><th className="p-3">Block</th><th className="p-3 text-right">Hours</th><th className="p-3 text-right">Gallons</th>
            </tr>
          </thead>
          <tbody>
            {data.logs.map((l, i) => (
              <tr key={l.id || i} data-testid={`portal-water-log-${i}`} className="border-t border-stone-200">
                <td className="p-3 font-mono">{l.date}</td>
                <td className="p-3 font-bold">{l.block_label}<span className="font-normal text-xs text-stone-500"> · {l.ranch_number}</span></td>
                <td className="p-3 text-right font-bold">{l.hours}</td>
                <td className="p-3 text-right">{l.gallons != null ? Number(l.gallons).toLocaleString() : "—"}</td>
              </tr>
            ))}
            {data.logs.length === 0 && (
              <tr><td colSpan={4} className="p-8 text-center text-stone-400 font-bold uppercase text-xs" data-testid="portal-water-logs-empty">No irrigation applied yet this season</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
